<template>
  <div class="screenBorder">
    <div class="">
      <p class="subtitle has-text-primary">
        {{ $t("survey") }}
      </p>

      <div v-if="hasSurvey && survey.options.personalization && !hasPermission">
        <b-field :label="$t('surveyLogin')" />
        <p class="control">
          {{ $t("persoSurveyDesc") }}
        </p>
        <b-input v-model="personalToken" type="password" class="my-2" size="is-medium" style="width: 100%" />
        <b-button
          class="surveyButton selected"
          size="is-medium"
          :disabled="personalToken.length != 6"
          @click="tryPersonalToken"
        >
          {{ $t("persoSurveySend") }}
        </b-button>
      </div>

      <div v-else-if="hasSurvey && survey.closed">
        <p class="">
          {{ $t("surveyThanks") }}
        </p>
      </div>

      <div v-else-if="hasSurvey">
        <div class="">
          <div v-if="hasQuestion">
            <p>
              <b>{{ question.question }}</b>
            </p>
            <div class="my-4">
              <!-- Here is VOTING -->
              <div v-show="!results">
                <div v-if="question.type == 'surveySelect'">
                  <div v-for="(option, key) in question.options" :key="key" class="mb-2" type="is-primary">
                    <b-button
                      size="is-medium"
                      style="width: 100%; white-space: normal; height: auto"
                      :class="answers[key] ? 'surveyButton selected' : 'surveyButton'"
                      :disabled="
                        (answers.filter((y) => y == true).length >= question.selectable && answers[key] == false) ||
                        !canVote
                      "
                      @click="
                        abstain = false;
                        $set(answers, key, !answers[key]);
                      "
                    >
                      {{ option.text }}
                    </b-button>
                  </div>
                  <div v-if="question.showAbstainBig">
                    <b-button
                      v-if="question.abstain"
                      size="is-medium"
                      style="width: 100%; white-space: normal; height: auto"
                      :class="abstain ? 'surveyButton selected' : 'surveyButton'"
                      :disabled="!canVote"
                      @click="toggleAbstain"
                    >
                      {{ $t("abstain") }}
                    </b-button>
                  </div>
                  <div v-else>
                    <a
                      v-if="question.abstain"
                      :disabled="!canVote"
                      :style="abstain ? 'color:#CCFF23' : 'color:black'"
                      @click="toggleAbstain"
                      ><u>{{ $t("abstain") }}</u>
                    </a>
                    <b-icon v-if="question.abstain && abstain" icon="check" size="is-small" />
                  </div>
                  <span v-if="question.selectable && false">({{ $t("selectable") + ": " + question.selectable }})</span>
                </div>
                <div v-else-if="question.type == 'surveySimple'">
                  <div class="mb-2">
                    <b-button
                      size="is-medium"
                      style="width: 48%; white-space: normal; height: auto"
                      :class="answers[0] ? 'surveyButton selected' : 'surveyButton'"
                      :disabled="!canVote"
                      @click="
                        abstain = false;
                        $set(answers, 1, false);
                        $set(answers, 0, true);
                      "
                    >
                      <!-- 20.10.2020 temporary -->
                      {{ $t(question.options[0].text) }}
                    </b-button>
                    <b-button
                      size="is-medium"
                      style="width: 48%; white-space: normal; height: auto"
                      :class="answers[1] ? 'surveyButton selected is-pulled-right' : 'surveyButton is-pulled-right'"
                      :disabled="!canVote"
                      @click="
                        abstain = false;
                        $set(answers, 0, false);
                        $set(answers, 1, true);
                      "
                    >
                      <!-- 20.10.2020 temporary -->
                      {{ $t(question.options[1].text) }}
                    </b-button>
                  </div>
                  <div v-if="question.showAbstainBig">
                    <b-button
                      v-if="question.abstain"
                      size="is-medium"
                      style="width: 100%; white-space: normal; height: auto"
                      :class="abstain ? 'surveyButton selected' : 'surveyButton'"
                      :disabled="!canVote"
                      @click="toggleAbstain"
                    >
                      {{ $t("abstain") }}
                    </b-button>
                  </div>
                  <div v-else>
                    <a
                      v-if="question.abstain"
                      :disabled="!canVote"
                      :style="abstain ? 'color:#CCFF23' : 'color:black'"
                      @click="toggleAbstain"
                      ><u>{{ $t("abstain") }}</u>
                    </a>
                    <b-icon v-if="question.abstain && abstain" icon="check" size="is-small" />
                  </div>
                </div>
              </div>
              <!-- Here are the rendered Results -->
              <div v-if="results && (question.showResults || question.onlyFinalResults)">
                <div v-if="question.type == 'surveySelect' || question.type == 'surveySimple'">
                  <RenderResults
                    style="max-width: 300px"
                    :question="question"
                    :responses="responses"
                    :server-answer="serverAnswer"
                  />
                </div>
              </div>
            </div>
            <!-- Button Control -->
            <b-field grouped group-multiline>
              <b-button
                v-if="!results && canVote"
                class="control surveyButton selected"
                size="is-medium"
                :disabled="!canSubmit"
                :loading="isLoading"
                @click="submit"
              >
                <span v-if="!justVoted">{{ $t("submit") }}</span>
                <span v-else><b-icon icon="check" /></span>
              </b-button>
              <b-button
                v-if="(question.showResults || (question.onlyFinalResults && question.closed)) && !results"
                class="control surveyButton"
                type="is-medium"
                :loading="isLoading"
                @click="handleResults(true)"
              >
                {{ $t("showResults") }}
              </b-button>
              <b-button
                v-if="results && canVote"
                class="control surveyButton selected"
                size="is-medium"
                :loading="isLoading"
                @click="handleResults(false)"
              >
                {{ $t("vote") }}
              </b-button>
              <b-button v-if="false" class="control surveyButton" size="is-medium" @click="goBackToCodeInput">
                {{ $t("goBackToCodeInput") }}
              </b-button>
            </b-field>
            <div v-if="hasQuestion && question.timed">
              <b-progress
                class="mt-4"
                :type="questionProgress < 50 ? 'is-success' : questionProgress < 80 ? 'is-warning' : 'is-danger'"
                :value="questionProgress"
                show-value
              >
                <span v-if="questionProgress < 100 && !question.closed" class="has-text-black">
                  {{
                    Math.floor(
                      question.duration - Math.abs(question.open_time.toDate().getTime() - new Date().getTime()) / 1000,
                    )
                  }}s
                </span>
                <span v-else class="has-text-black">
                  {{ $t("closed") }}
                </span>
              </b-progress>
            </div>
          </div>
          <div v-else>
            <div class="">
              <p class="">
                {{ $t("noActiveSurvey") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p class="">
          {{ $t("noActiveSurvey") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 } from "uuid";
import { db, functions } from "@/firebase";
import RenderResults from "@/components/survey/RenderResults";

export default {
  name: "SurveyPresentation",
  components: {
    RenderResults,
  },
  props: {
    survey: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      codeInput: "", // survey code, 4 letters
      personalToken: "", // optinal, for personal surveys, 6 letters
      answers: [], // answer array
      serverAnswer: {}, // firestore doc of what current user has voted
      interval: null, // JS interval to check duration of question
      results: false, // Boolean, if results are currently shown or if the question is currently shown
      responses: null, // firestore doc with all the results
      loadedQuestion: null, // index like currentQuestion, to check if question has changed
      questionProgress: null, // percentage between 0-100, to track duration of timed questions
      isDisabled: false,
      isLoading: false,
      hasPermission: false, // if the personal token was correct,
      abstain: false,
      justVoted: false,
    };
  },
  computed: {
    canVote() {
      if (this.survey && this.question && !this.question.closed) {
        if (!this.question.timed || this.questionProgress < 100) {
          return true;
        }
      }
      return false;
    },
    canSubmit() {
      if (this.answers && this.answers.filter((y) => y == true).length > 0) {
        return true;
      }
      if (this.abstain && this.question.abstain) {
        return true;
      }
      return false;
    },
    question() {
      if (this.hasSurvey) {
        if (this.survey.currentQuestion != null) {
          return this.survey.questions[this.survey.currentQuestion];
        }
      }
      clearInterval(this.interval);
      return {};
    },
    hasSurvey() {
      return this.survey != null && Object.keys(this.survey).length != 0;
    },
    hasQuestion() {
      return this.question != null && Object.keys(this.question).length != 0;
    },
  },
  watch: {
    survey: {
      immediate: true,
      handler() {
        if (this.hasSurvey) {
          if (this.loadedQuestion != this.survey.currentQuestion) {
            this.resetForNextQuestion();
            this.startTimer();
            if (this.question.showResults) {
              //this.loadAnswers()
              //this.loadPreviousAnswer()
            }
            this.loadedQuestion = this.survey.currentQuestion;
          } else if (this.question.timed && !this.question.closed) {
            this.startTimer();
          }
        }
      },
    },
    question: {
      immediate: true,
      handler() {
        if (this.question) {
          if (this.question.closed) {
            this.handleResults(true);
          } else if (this.question.onlyFinalResults) {
            this.handleResults(false);
          }
          if (Object.keys(this.question).length != 0) {
            this.$emit("new-question");
          }
          if (this.question.type == "surveySelect" || this.question.type == "surveySimple") {
            this.answers = [];
            for (let option of Object(this.question.options).keys()) {
              this.answers[option] = false;
            }
          }
        }
      },
    },
    answers: {
      deep: true,
      handler() {
        this.justVoted = false;
        if (this.question.type == "surveySelect" || this.question.type == "surveySimple") {
          if (this.answers.filter((y) => y == true).length > 0) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
          }
        }
      },
    },
  },
  mounted() {
    if (localStorage.getItem("surveyToken") == null) {
      localStorage.setItem("surveyToken", v4());
    }
    if (this.surveyCode) {
      this.codeInput = this.surveyCode;
    }
  },
  methods: {
    toggleAbstain() {
      if (this.canVote) {
        this.abstain = !this.abstain;
        if (this.question.type == "surveySelect" || this.question.type == "surveySimple") {
          this.answers = [];
          for (let option of Object(this.question.options).keys()) {
            this.answers[option] = false;
          }
        }
      }
    },
    goToSurvey() {
      this.$router.push({
        name: "Polling",
        params: { surveyCode: this.codeInput },
      });
    },
    goBackToCodeInput() {
      this.reset();
    },
    // check if user can switch view to results & begin loading answers
    async handleResults(value) {
      if (this.question.onlyFinalResults) {
        if (this.question.closed) {
          this.results = value;
          if (value && this.responses == null) {
            this.loadAnswers();
          }
        } else {
          this.results = false;
        }
      } else if (this.question.showResults) {
        this.results = value;
        if (value && this.responses == null) {
          this.loadAnswers();
        }
      } else {
        this.results = false;
      }
    },
    async loadAnswers() {
      this.$bind(
        "responses",
        db.collection("surveys").doc(this.survey.id).collection("answers").doc(this.survey.currentQuestion.toString()),
      );
    },
    async loadPreviousAnswer() {
      this.$bind(
        "serverAnswer",
        db
          .collection("surveys")
          .doc(this.survey.id)
          .collection("answers")
          .doc(this.survey.currentQuestion.toString())
          .collection("votes")
          .doc(localStorage.getItem("surveyToken")),
      );
    },
    startTimer() {
      this.questionProgress = 0;
      this.interval = setInterval(this.checkProgress, 700);
    },
    checkProgress() {
      if (this.question) {
        if (this.question.timed) {
          this.questionProgress =
            (Math.abs(this.question.open_time.toDate().getTime() - new Date().getTime()) /
              1000 /
              this.question.duration) *
            100;
          console.log(this.questionProgress);
          this.isDisabled = false;
          if (this.questionProgress >= 100) {
            this.questionProgress = 100;
            this.isDisabled = true;
            clearInterval(this.interval);
            this.handleResults(true);
          }
          if (this.question.closed) {
            this.questionProgress = 100;
            this.isDisabled = true;
            clearInterval(this.interval);
            this.handleResults(true);
          }
          return;
        }
        clearInterval(this.interval);
      }
      clearInterval(this.interval);
    },
    async submit() {
      try {
        this.isDisabled = true;
        this.isLoading = true;
        await functions.httpsCallable("AnswerSurvey")({
          surveyId: this.survey.id,
          questionId: this.survey.currentQuestion.toString(),
          answer: this.answers,
          surveyToken: localStorage.getItem("surveyToken"),
          timestamp: new Date(),
          personalToken: this.personalToken,
          abstain: this.abstain,
        });
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("voteAccepted"),
        });
        this.justVoted = true;
        this.handleResults(true);
      } catch (error) {
        this.$buefy.toast.open({
          type: "is-warning",
          message: this.$t("voteNotAccepted"),
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    reset() {
      this.codeInput = "";
      this.personalToken = "";
      this.survey = {};
      this.answers = [];
      this.serverAnswer = {};
      clearInterval(this.interval);
      this.interval = null;
      this.results = false;
      this.responses = null;
      this.loadedQuestion = null;
      this.questionProgress = null;
      this.isDisabled = false;
      this.isLoading = false;
      this.hasPermission = false;
    },
    resetForNextQuestion() {
      this.isLoading = false;
      this.isDisabled = false;
      this.answers = [];
      this.serverAnswer = {};
      this.questionProgress = 0;
      this.abstain = false;
      this.responses = null;
      this.handleResults(false);
      clearInterval(this.interval);
    },
    async tryPersonalToken() {
      this.isLoading = true;
      this.isDisabled = true;
      try {
        let filteredPersons = this.survey.persons.filter((y) => y.personalToken == this.personalToken);

        if (filteredPersons.length > 0) {
          this.hasPermission = true;
        } else {
          throw false;
        }
      } catch (error) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$t("surveyPermissionNotFound"),
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style>
.surveyButton {
  background-color: #d3d3d3;
  border-color: #121c2e;
  color: black;
  width: 100%;
}
.surveyButton.selected {
  background-color: #ccff23;
  border-color: #a4ce1b;
  color: black;
}

.screenBorder {
  margin: 20px;
}
</style>
